import { Link } from 'react-router-dom';
import { mangas } from '@/mocks/manga';

export default function AllMangaGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            全部作品
          </span>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            全部刃牙漫画系列
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            完整收录刃牙全系列及相关格斗漫画作品，一次看个够
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5 md:gap-6">
          {mangas.map((manga) => (
            <Link
              key={manga.slug}
              to={`/article/${manga.slug}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-200">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={`${manga.title} - 刃牙漫画在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${
                    manga.status === '连载中'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-800/80 text-background-100'
                  }`}>
                    {manga.status}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                {manga.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{manga.author}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-foreground-400">{manga.totalChapters}话</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}